import { createPath } from 'history';
import { parse } from 'qs';
import { createElement, FC, useContext } from 'react';
import { Redirect, RouteComponentProps } from 'react-router';

import { SessionStorage } from '../../adapter/BrowserStore';
import { BusinessRegionAdRegionKey, OrganizationDetailFragment } from '../../generated/graphql';
import mergeUrlQuery from '../../utility/mergeUrlQuery';
import { context as DependencyContext } from '../context/dependency';
import { context as HistoryContext } from '../context/history';
import { context as StateContext } from '../context/state';
import Page from '../page/ConfigurationPage';
import TrialPage from '../page/TrialConfigurationPage';

type Props = RouteComponentProps;

const ConfigurationPage: FC<Props> = () => {
  const state = useContext(StateContext);
  const history = useContext(HistoryContext);
  const dependency = useContext(DependencyContext);
  const isOpendByIframe = SessionStorage.getItem('sidenav=cloud') === 'true' ? true : false;

  const query = parse(state.location.search.slice(1));
  const organizationId = query.org;
  let organization: OrganizationDetailFragment;

  const region: BusinessRegionAdRegionKey =
    state.lastAccessedOrganization != null && state.lastAccessedOrganization.businessRegion.key
      ? state.lastAccessedOrganization.businessRegion.key
      : 'jp';

  if (state.lastAccessedOrganization) {
    organization = state.lastAccessedOrganization;
  } else {
    organization = state.availableOrganizations.items[0];
  }

  // クエパラにorganizationIdが存在しない場合はリダイレクトする
  if (!organizationId && organization) {
    return <Redirect to={createPath(mergeUrlQuery(history.location, { org: organization.id }))} />;
  }

  if (!organization) {
    return (
      <TrialPage
        language={state.language}
        onChangeLanguage={(_: any, locale: string) => dependency.configurationChangingUsecase.changeLanguage(locale)}
        onMount={() => {
          dependency.authenticationUsecase.needSignedIn();
        }}
        onUnmount={() => undefined}
      />
    );
  } else {
    return (
      <Page
        loading={state.integratedFacebookAdAccounts.fetching >= 1}
        point={organization.pointBalance ?? null}
        organizationId={organization.id}
        language={state.language}
        region={region}
        availableOrganizations={state.availableOrganizations.items}
        selectedOrganization={state.lastAccessedOrganization}
        isOpendByIframe={isOpendByIframe}
        onChangeSelectedOrganization={(_: any, organization: OrganizationDetailFragment) =>
          history.push(`/latest-insights?org=${organization.id}`)
        }
        onChangeLanguage={(_: any, locale: string) => dependency.configurationChangingUsecase.changeLanguage(locale)}
        onMount={() => {
          dependency.authenticationUsecase.needSignedIn();
          dependency.authenticationUsecase.setInitOrganization();
          dependency.organizationUsecase.refreshPointBalance(organizationId);
          dependency.sendCreativeToFacebookUsecase.fetchIntegratedFacebookAdAccounts(organizationId);
          dependency.sendCreativeToYoutubeUsecase.fetchChannels();
          dependency.integrateGoogleAdAccountUsecase.fetchIntegratedGoogleAdAccounts(organizationId);
          dependency.integrateAmazonAdAccountUsecase.fetchIntegratedAmazonAdAccounts(organizationId);
          dependency.integrateYahooAdAccountUsecase.fetchIntegratedYahooAdAccounts(organizationId);
          dependency.integrateTiktokAdAccountUsecase.fetchIntegratedTiktokAdAccounts(organizationId);
        }}
        onUnmount={() => undefined}
      />
    );
  }
};

export default ConfigurationPage;
